import Radio from "../../Components/Radio";
import Input from "../../Components/Input";
import Badge from "../../Components/Badge";
import EditIcon from "../../Assets/Icons/outline/edit.svg";
import TrashIcon from "../../Assets/Icons/outline/trash.svg";
import AdminContext from "../../Services/Admin";
import { Fragment, use, useContext, useEffect } from "react";

const CloseProjectModal = ({
	dataContributor,
	setDataContributor,
	register,
	errors,
	control,
	watch,
	dataProject,
	dataTask,
	setValue,
	reset,
}) => {
	const { loading, getAllMaster } = useContext(AdminContext);

	const getProjectContributor = async (project_id) => {
		const res = await getAllMaster(`project/${project_id}/contributor`);
		setDataContributor(res);
	};

	const isGoal = watch("is_goal") === "true";
	// const bonus = watch("bonus") || 0;
	const isProjectDone = dataProject?.status === "Completed" ? true : false;

	useEffect(() => {
		if (dataProject?.id) {
			getProjectContributor(dataProject.id);
		}
	}, [dataProject?.id]);

	const dataLoad = dataContributor && dataContributor?.contributors?.length > 0;

	const totalPoints = dataLoad
		? dataContributor?.contributors.reduce((sum, item) => sum + (Number(item.points) || 0), 0)
		: 0;

	return (
		<>
			{dataContributor && (
				<div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
						{/* PROJECT NAME */}
						<div>
							<div className="text-gray-500 mb-1">Project Name</div>
							<div className="font-medium text-gray-800">{dataContributor.project_name || "-"}</div>
						</div>
						{/* PROJECT STAUS */}
						<div>
							<div className="text-gray-500 mb-1">Status</div>
							<div className="font-medium text-gray-800">{dataProject?.status || "-"}</div>
						</div>

						{/* DEADLINE */}
						<div>
							<div className="text-gray-500 mb-1">Deadline</div>
							<div className="font-medium text-gray-800">
								{dataContributor.start && dataContributor.end
									? `${dataContributor.start} → ${dataContributor.end}`
									: "-"}
							</div>
						</div>
					</div>
				</div>
			)}
			<div className="mb-5">
				<label htmlFor="status" className="block mb-3">
					Is project Goal? <span className="text-red-500">*</span>
				</label>

				<div className="flex">
					<Radio id="status" label="Yes" value="true" name="status" required {...register("is_goal")} />
					<Radio
						id="status-2"
						label="No"
						value="false"
						name="status"
						required
						{...register("is_goal", {
							onChange: (e) => {
								// Jika memilih "No", set bonus ke 0
								if (e.target.value === "false") {
									setValue("bonus", 0);
								}
							},
						})}
					/>
				</div>
			</div>
			{dataContributor?.contributors?.length > 0 && (
				<table className="w-full text-left">
					<thead>
						<tr>
							<th>No</th>
							<th>Name</th>
							<th>Roles</th>
							<th>
								<span>Points (1-10)</span>
							</th>
							<th>Percentage</th>
							{/* <th>Bonus</th> */}
						</tr>
					</thead>

					<tbody>
						{dataContributor.contributors.map((item, index) => {
							const percentage = totalPoints > 0 ? (item.points / totalPoints) * 100 : 0;

							// const calculatedBonus = isGoal ? (bonus * percentage) / 100 : 0;

							return (
								<Fragment key={item.id}>
									<tr>
										<td>{index + 1}</td>

										<td>
											<div>{item?.name}</div>
											{/* <div>{item?.email}</div> */}
										</td>
										<td>
											<div>{item?.roles[0]}</div>
										</td>

										{/* INPUT POINT */}
										<td className="pr-8 text-left w-[130px]">
											<Input
												id="bonus"
												placeholder="Input Bonus"
												required
												type="number"
												value={item.points}
												onChange={(e) => {
													const value = Number(e.target.value) || 0;
													const max10 = value > 10 ? 10 : value;

													setDataContributor((prev) => ({
														...prev,
														contributors: prev.contributors.map((c) =>
															c.id === item.id ? { ...c, points: max10.toString() } : c,
														),
													}));
												}}
											/>
										</td>

										{/* PERCENTAGE */}
										<td>{percentage.toFixed(2)}%</td>

										{/* BONUS */}
										{/* <td>
										{calculatedBonus.toLocaleString("id-ID", {
											maximumFractionDigits: 0,
										})}
									</td> */}
									</tr>
									{/* ACCORDION ROW */}
									<tr className="bg-gray-50">
										<td colSpan={5} className="p-0">
											<details className="group">
												<summary className="cursor-pointer px-4 py-2 text-sm text-blue-600 hover:bg-gray-100 flex items-center justify-between">
													<span>Lihat detail project</span>
													<span className="transition-transform group-open:rotate-180">▼</span>
												</summary>

												{/* CONTENT (TESTER) */}
												<div className="px-6 py-4 text-sm text-gray-600">
													<ul className="list-disc pl-5 space-y-1">
														{item.tasks.map((t) => (
															<li key={t.id}>
																{dataContributor.project_name} — {t.name} : {t.status}
															</li>
														))}
													</ul>
												</div>
											</details>
										</td>
									</tr>
								</Fragment>
							);
						})}
					</tbody>
				</table>
			)}
			<div className="py-4"></div>

			{!isProjectDone && (
				<small className={`text-[red]`}>{"Project belum selesai, selesaikan semua task terlebih dahulu!"}</small>
			)}

			{/* <div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Bonus <span className="text-red-500">*</span>
				</label>
				<Input
					id="bonus"
					placeholder="Input Bonus"
					required
					type="number"
					disabled={watch("is_goal") === "false"}
					{...register("bonus", { valueAsNumber: true })}
					errors={errors?.bonus?.message}
				/>
			</div> */}
		</>
	);
};

export default CloseProjectModal;
